export default __webpack_public_path__ + "static/media/log.07afb4f9.png";